// extracted by mini-css-extract-plugin
export var circle = "_g5-1";
export var exitConfirmationModal = "_g5-5";
export var iframe = "_g5-0";
export var offline = "_g5-3";
export var online = "_g5-2";
export var workstationSelectError = "_g5-4";